import React, { useContext, useEffect, useState } from 'react';
import $ from 'jquery';
import { Box, Button, Radio, RadioGroup, Stack } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { toast } from 'react-toastify';
import Toast from '../../../../components/Toast';
import { options } from '../../../../helpers/toastOptions';
import { useIntegration } from '../../../../hooks/Integration';
import { useManager } from '../../../../hooks/Manager';
import { useModal } from '../../../../hooks/Modal';
import { usePickup } from '../../../../hooks/Pickup';
import { parseCpfCnpj } from '../../../../helpers/parseValues';
import { DefaultCollectContext } from '../..';
import { ModalTitle } from './styled';

export const ModalChangeCollectAddress = () => {
  const [radio, setRadio] = useState('');
  const [searchingForRestriction, setSearchingForRestriction] = useState(false);

  const { verifyUserRestriction } = useIntegration();
  const {
    getPickupManagerParameterization,
    getPickupManagerBranchValidations
  } = useManager();
  const { closeModal, openModal, Modal } = useModal();
  const { cancelDefaultPickup } = usePickup();

  const {
    openAddCollectAddressModal,
    addressList,
    setIsToValidateSenderAddressNumber,
    selectedAddressIndex,
    setSelectedAddressIndex,
    setProtocolCollectCanceled
  } = useContext(DefaultCollectContext);

  const handleChangeRadio = (event) => {
    setRadio(event.target.value);
  };

  const handleSetAddress = async () => {
    const index = parseInt(radio.replace('address', ''), 10);

    const hasInvalidAddressSelected =
      !addressList[index].name ||
      !addressList[index].document ||
      !addressList[index].zipPostalCode ||
      !addressList[index].streetAddress ||
      !addressList[index].streetAddressNumber ||
      !addressList[index].suburb ||
      !addressList[index].city ||
      !addressList[index].state ||
      !addressList[index].contactName ||
      !addressList[index].contactNumber ||
      !addressList[index].contactEmail;

    if (hasInvalidAddressSelected) {
      toast(
        <Toast
          title="Atenção!"
          content="Selecione um endereço que contenha todas informações obrigatórias."
          type="error"
        />,
        options
      );

      return;
    }

    try {
      setSearchingForRestriction(true);

      const pickupManagerResponse = await getPickupManagerParameterization({
        branchId: 1,
        transportTypeId: 9,
        pickupTypeId: 1,
        inputTypeId: 5
      });

      if (pickupManagerResponse?.length > 0) {
        const validationResponse = await getPickupManagerBranchValidations({
          branchParameterizationId:
            pickupManagerResponse[0]?.branchParameterizationId
        });

        if (validationResponse?.length > 0) {
          if (
            validationResponse[0]?.validatePendingCharge ||
            validationResponse[0]?.validateLegalPending
          ) {
            const userHasRestriction = await verifyUserRestriction({
              document: parseCpfCnpj(addressList[index].document)
            });

            if (userHasRestriction?.isBlocked) {
              const address = {
                zipPostalCode: addressList[index].zipPostalCode,
                streetAddress: addressList[index].streetAddress,
                streetAddressNumber: addressList[index].streetAddressNumber,
                additionalInformation: '',
                suburb: addressList[index].suburb,
                city: addressList[index].city,
                state: addressList[index].state,
                country: ''
              };

              const cancelResponse = await cancelDefaultPickup({
                data: {
                  pickup: {
                    requesterCorporation: {
                      requesterType: 'sender',
                      document: parseCpfCnpj(addressList[index].document),
                      name: addressList[index].name,
                      address,
                      contactList: []
                    },
                    shipmentList: [
                      {
                        transportTypeId: null,
                        freightTypeId: null,
                        senderCorporation: {
                          document: parseCpfCnpj(addressList[index].document),
                          name: addressList[index].name,
                          address,
                          contactList: []
                        },
                        receiverCorporation: null,
                        shipmentAvailability: null,
                        shipmentPackageList: null,
                        taxInformation: null
                      }
                    ],
                    pickupCancelType: 'Restrição Financeira ou Jurídica'
                  }
                }
              });

              if (cancelResponse.status === 200) {
                setProtocolCollectCanceled(cancelResponse.data.data.protocol);
              }

              openModal('modalFinancialRestriction');

              return;
            }
          }
        }
      }

      setIsToValidateSenderAddressNumber(false);
      setSelectedAddressIndex(index);
      closeModal();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);

      setSearchingForRestriction(false);
    }
  };

  const handleCloseModal = () => {
    closeModal();
  };

  useEffect(() => {
    setRadio(`address${selectedAddressIndex}`);

    $('#zipPostalCode').mask('00000-000');

    $('#phoneNumber').mask('(00) 0000-00000');
  }, []);

  return (
    <Modal>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
          maxHeight: '86vh',
          overflow: 'auto'
        }}
      >
        <ModalTitle>ENDEREÇO DE COLETA</ModalTitle>

        <RadioGroup name="collectAddress">
          <Stack spacing={3}>
            {addressList.map((userAddress, index) => (
              <Stack
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                direction="row"
                spacing={2}
                alignItems="center"
              >
                <Radio
                  name="collectAddress"
                  id={`address${index}`}
                  value={`address${index}`}
                  data-testid={`address${index}RadioButton`}
                  disabled={
                    !userAddress.name ||
                    !userAddress.document ||
                    !userAddress.zipPostalCode ||
                    !userAddress.streetAddress ||
                    !userAddress.streetAddressNumber ||
                    !userAddress.suburb ||
                    !userAddress.city ||
                    !userAddress.state ||
                    !userAddress.contactName ||
                    !userAddress.contactNumber ||
                    !userAddress.contactEmail
                  }
                  checked={radio === `address${index}`}
                  onChange={handleChangeRadio}
                />
                <label
                  htmlFor={`address${index}`}
                  style={{ cursor: 'pointer' }}
                >
                  {userAddress.name} - {userAddress.document}
                  <br />
                  CEP:{' '}
                  <span id="zipPostalCode">
                    {userAddress.zipPostalCode}
                  </span>, {userAddress.streetAddress}
                  {userAddress.streetAddressNumber &&
                    `, ${userAddress.streetAddressNumber}`}
                  {userAddress.additionalInformation &&
                    `, ${userAddress.additionalInformation}`}
                  , {userAddress.suburb}, {userAddress.city}-{userAddress.state}
                  <br />
                  <div>
                    CONTATO: {userAddress.contactName}
                    {userAddress.contactNumber !== '' && (
                      <>, {userAddress?.contactNumber}</>
                    )}
                    {userAddress.contactExtension &&
                      `, RAMAL ${userAddress?.contactExtension}`}
                    , {userAddress?.contactEmail}
                  </div>
                </label>
              </Stack>
            ))}
          </Stack>
        </RadioGroup>

        <Button
          type="button"
          data-testid="addNewAddressButton"
          onClick={openAddCollectAddressModal}
        >
          Adicionar novo endereço
        </Button>

        <Stack direction="row" spacing={2} marginTop={1}>
          <Button
            type="button"
            variant="contained"
            color="secondary"
            data-testid="closeChangeCollectAddressModalButton"
            onClick={handleCloseModal}
            disabled={!!searchingForRestriction}
          >
            Cancelar
          </Button>
          <LoadingButton
            type="button"
            data-testid="confirmChangeCollectAddressModalButton"
            variant="contained"
            onClick={handleSetAddress}
            loading={!!searchingForRestriction}
            disabled={!!searchingForRestriction}
          >
            Confirmar
          </LoadingButton>
        </Stack>
      </Box>
    </Modal>
  );
};
